import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ContentWrapper from '../ContentWrapper';
import FormCard from '../FormCard';
import ProfessionalProfile from './components/ProfessionalProfile';
import AdditionalMedia from './components/AdditionalMedia';
import { useProfessionalProfile } from 'hooks/newUniprofile/useProfessionalProfile';
import { Spin } from 'antd';

interface ProfessionalProfileStepProps {
    isReview?: boolean;
}

const ProfessionalProfileStep = forwardRef(({ isReview = false }: ProfessionalProfileStepProps, ref) => {
    const [professionalProfile, loading, refetch] = useProfessionalProfile();
    const profileRef = useRef<any>();
    const additionalMediaRef = useRef<any>();
    console.log('professionalProfile', professionalProfile);

    const onSubmit = async () => {
        try {
            await Promise.all([
                profileRef.current?.onValidate(),
                additionalMediaRef.current?.onValidate(),
            ]);

            // 在 next 时只需要保存 profile 即可
            if (profileRef.current) {
                await profileRef.current.onSubmit();
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    const hasAdditionalMedia = Boolean(professionalProfile?.additionalPhotoList?.length || professionalProfile?.videoList?.length || professionalProfile?.foreignLanguage);

    return (
        <Spin spinning={loading}>
            <ContentWrapper title="Professional profile" description="Create a profile patients can see when they search for care." showInfo={!isReview}>
                <FormCard type={isReview ? 'review' : 'edit'} title="Professional profile" showHeader={isReview} ref={profileRef}>
                    {(isEditing) => <ProfessionalProfile isEditing={isEditing} initValue={professionalProfile} refetch={refetch} />}
                </FormCard>
                <FormCard type={isReview ? 'review' : 'add'} title="Additional Media" isOptional ref={additionalMediaRef} hasContent={hasAdditionalMedia}>
                    {(isEditing) => <AdditionalMedia isEditing={isEditing} initValue={professionalProfile} refetch={refetch} />}
                </FormCard>
            </ContentWrapper>
        </Spin>
    );
});

export default ProfessionalProfileStep;
